import * as actions from '../actions/overviewTab';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestGetOverviewVisibilityOptions(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_OVERVIEW_VISIBILITY_OPTIONS)
        .map(action => ({
            url: BASE_URL + 'api/Applications/Overview/VisibilityOptions',
            category: 'requestGetOverviewVisibilityOptions',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestGetOverviewVisibilityOptions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveOverviewVisibilityOptions(JSON.parse(response.text)))

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function failedRequestOverviewVisibilityOptions(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetOverviewVisibilityOptions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.failedToGetOverviewVisibilityOptions([]))

    return {
        ACTION: httpResponse$
    };
}